import type { ReactNode } from 'react';

import { VStack } from '@frontend/components';

type FormPreviewSectionProps = {
  children: ReactNode;
};

export const FormPreviewSection = ({ children }: FormPreviewSectionProps) => {
  return (
    <VStack
      align="center"
      bg="page.background"
      borderRadius="md"
      border="1px solid"
      borderColor="separator.divider"
      p={1}
      mx={1}
    >
      {children}
    </VStack>
  );
};
